export const POLL = "poll"
export const RECOGNITION = "recognition"
export const GROUP_CELEBRATION = "group-celebration"
export const REWARD = "reward"
export const COMMENT = "comment"
